<!-- レーダ軸調整 ダイアログ -->
<b-modal v-model="modal_requirement_155" size="md" :header-bg-variant="headerColor" header-text-variant="light"
  no-close-on-backdrop no-close-on-esc centered no-stacking>
  <template v-slot:header>
    <div class="text-center w-100">
      {{ headerTitle }}
    </div>
  </template>

  <template v-slot:default>
    <b-overlay :show="isLoading" opacity="0.3" spinner-variant="primary">
      <div class="container-fluid" style="min-height: 140px;">
        <div class="w-100">
          <div class="box-margin-right work-support-message" style="white-space: break-spaces;">
            {{ workSupportMessage }}
          </div>
        </div>
      </div>
    </b-overlay>
  </template>

  <template v-slot:footer>
    <div class="w-100 text-center ">
      <b-button v-if="showButtonOk" size="sm" variant="primary" @click="onOkClicked" class="mx-2" :disabled="isLoading">
        {{ $t('message.common_button_ok') }}
      </b-button>
      <b-button v-if="showButtonCancel" size="sm" variant="outline-primary" @click="closeWizard" class="mx-2"
        :disabled="isLoading">
        {{ $t('message.common_button_cancel') }}
      </b-button>
    </div>
  </template>
</b-modal>